import React from 'react';
import './PesoCompliance.css'; // Create a CSS file for specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import backgroundimg from '../../assets/images/peso_dummy_1.jpg';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_peso_banner from '../../assets/images/img_peso1_banner.png'; // Replace with an appropriate image path
import { FaShieldAlt, FaClipboardCheck, FaTools, FaGavel, FaFileAlt, FaComments, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function PesoCompliance() {
  const benefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Ensure Safety',
      text: 'Adhere to PESO guidelines to guarantee safety in handling hazardous materials.',
    },
    {
      icon: <FaClipboardCheck />,
      title: 'Regulatory Compliance',
      text: 'Comply with the Petroleum and Explosives Safety Organization’s rules to avoid penalties.',
    },
    {
      icon: <FaTools />,
      title: 'Operational Efficiency',
      text: 'Streamline processes and maintain compliance without operational interruptions.',
    },
    {
      icon: <FaGavel />,
      title: 'Avoid Legal Issues',
      text: 'Fulfill legal obligations under PESO regulations and prevent penalties.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Consultation',
      description: 'Discuss your compliance needs and evaluate your current practices.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Documentation Preparation',
      description: 'Prepare the required documents for PESO compliance submission.',
    },
    {
      icon: <FaTools />,
      title: 'Compliance Assessment',
      description: 'Conduct on-site inspections and assessments for compliance readiness.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Submission and Approval',
      description: 'Submit compliance documents to PESO and follow up for approvals.',
    },
    {
      icon: <FaCertificate />,
      title: 'Certification and Audit',
      description: 'Receive the compliance certification and periodic audits for maintenance.',
    },
  ];

  const acts = [
    'Explosives Act, 1884',
    'Gas Cylinder Rules, 2016',
    'Petroleum Rules, 2002',
    'Static and Mobile Pressure Vessels Rules, 1981',
  ];

  const explanation =
    'PESO Compliance is crucial for businesses handling hazardous materials such as petroleum, explosives, and compressed gases. Adhering to these regulations ensures safety, legal compliance, and operational efficiency, minimizing risks and maintaining trust with stakeholders.';

  const checklistItems = [
    { name: 'Application Form', description: 'Duly filled PESO compliance application form.' },
    { name: 'Site Layout Plan', description: 'Detailed layout plan of the site as per PESO requirements.' },
    { name: 'Safety Equipment List', description: 'List of safety equipment installed on the premises.' },
    { name: 'Third-Party Testing Reports', description: 'Reports from authorized agencies verifying safety standards.' },
    { name: 'Training Records', description: 'Proof of staff training on safety and hazardous material handling.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="PESO Compliance Services"
        subheading="Ensure the safety, compliance, and smooth operations of your hazardous material handling facilities with our expert PESO services."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/peso' }}
        backgroundImage={backgroundimg} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is PESO Compliance?"
        description="PESO (Petroleum and Explosives Safety Organization) compliance is essential for businesses dealing with hazardous materials. Our services help you navigate the complex regulations, ensuring safety and operational compliance."
        image={img_peso_banner} // Replace with a relevant image
        altText="PESO Compliance Process"
      />

      <ServicesBenefitsSection
        title="Why PESO Compliance Matters?"
        description="Understand the importance of meeting PESO regulations for safety and operational efficiency."
        benefits={benefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Legal Standards for PESO Compliance"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our PESO Compliance Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="PESO Compliance Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
